import { ConfAccount } from "../../context/account/paramsAccount";
import { saveModeHorsligne } from "../localStorage/saveLocalStorage";
import { loadModeHorsligne } from "./loadmodeHL";


export async function savePrestaHl(entete: any, details: any, showModal: (message: string) => void,conf:ConfAccount) {
    try {
        const existingData = await loadModeHorsligne('prestaHl',conf);
        const updatedData = existingData.map((item: any) => {
            if (item.entete.pv_id === entete?.pv_id && item.entete.dev_id === entete?.dev_id) {
                return {
                    ...item,
                    result: details,
                };
            }
            return item;
        });
        // showModal("La prestation a bien été enregistrée.")
        await saveModeHorsligne(updatedData, 'prestaHl',conf);
    } catch (error) {
        console.error('Erreur lors de l\'enregistrement des données hors ligne :', error);
    }
};
export const savePrestaToLocalStorage = async (
    entete: any,
    details: any,
    conf:ConfAccount
) => {
    try {
        // Charger les données existantes du localStorage
        const existingData = await loadModeHorsligne('prestaHl',conf);

        // Mettre à jour les données pertinentes
        const updatedData = existingData.map((item: any) => {
            if (item.entete.pv_id === entete?.pv_id && item.entete.dev_id === entete?.dev_id) {
                return {
                    ...item,
                    result: details, // Met à jour avec les nouvelles données
                };
            }
            return item; // Pas de modification pour les autres
        });

        // Sauvegarder les données mises à jour dans le localStorage
        await saveModeHorsligne(updatedData, 'prestaHl',conf);
    } catch (error) {
        console.error('Erreur lors de la sauvegarde dans le localStorage :', error);
    }
};
